/* Coș: ține legate materialul și manopera din calculator + deschide/reîmprospătează coșul lateral Kalles */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Grupul și rolul unei linii din coș: din „Configurație” + detaliile vizibile
     (cu compatibilitate pentru liniile vechi cu proprietăți _hdc_) */
  var CFG_KEY = 'Configurație';
  function hdcGroupOf(p) { p = p || {}; return p[CFG_KEY] || p._hdc_grup || null; }
  function hdcRoleOf(p) {
    p = p || {};
    if (p._hdc_rol) return p._hdc_rol;
    if (!p[CFG_KEY]) return null;
    if (p['Tip manoperă']) return 'material';
    if (p['Poziție']) return 'accesoriu';
    if (p['Serviciu pentru']) return 'serviciu';
    if (p['Total metraj material']) return 'manopera';
    return null;
  }
  var DIM_KEY = 'Dimensiuni pe bucată';
  function hdcDims(p) { p = p || {}; return String(p[DIM_KEY] || p['Dimensiuni'] || ''); }
  function hdcIsSplit2(p) { p = p || {}; return /panouri|în 2/i.test(String(p['Împărțire'] || p['Tip împărțire'] || '')); }
  // Textul pentru croitorie: câte panouri și ce lățime
  function hdcSplitText(len, split2, pcs) {
    if (split2) return '2 panouri × ' + (len / 2) + ' cm pe bucată' + (pcs > 1 ? ' (' + (pcs * 2) + ' panouri în total)' : '');
    return 'bucată întreagă' + (pcs > 1 ? ' (' + pcs + ' bucăți în total)' : '');
  }
  function hdcMetersPerPiece(p) {
    p = p || {};
    var u = parseInt(p._hdc_unitati, 10);
    if (u) return u;
    var m = hdcDims(p).match(/(\d+)/);
    return m ? Math.max(1, Math.round(parseInt(m[1], 10) / 100)) : 1;
  }

  var busy = false;

  /* ---------- Ajutoare ---------- */
  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  function merge(a, b) {
    var o = {}, k;
    for (k in a) o[k] = a[k];
    for (k in b) o[k] = b[k];
    return o;
  }

  /* ---------- Coșul lateral Kalles ---------- */
  function drawerEl() { return document.getElementById('t4s-mini_cart'); }

  function drawerTrigger() {
    return document.querySelector('[data-drawer-options*="mini_cart"]') ||
           document.querySelector('[data-id="#t4s-mini_cart"]');
  }

  // Reîncarcă DOAR părțile care se schimbă în coșul lateral (produse, prețuri, reduceri, bara de transport).
  // Structura drawer-ului (butoane, formular, panouri) rămâne cea originală Kalles, cu evenimentele ei.
  var DRAWER_PARTS = ['[data-cart-items]', '[data-cart-prices]', '[data-cart-discounts]', '[data-cart-calc-shipping]'];

  function refreshDrawer() {
    var drawer = drawerEl();
    var jobs = [];

    if (drawer) {
      jobs.push(
        fetch(root + 'cart?section_id=mini_cart', { headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var hasStructure = drawer.querySelector('[data-cart-items]');
            if (!hasStructure) {
              // Drawer-ul nu a fost încă încărcat de Kalles: îl lăsăm pe Kalles să-l încarce la deschidere
              return;
            }
            DRAWER_PARTS.forEach(function (sel) {
              var fresh = doc.querySelector(sel);
              var current = drawer.querySelector(sel);
              if (fresh && current) current.innerHTML = fresh.innerHTML;
            });
          })
      );
    }

    jobs.push(
      fetch(root + 'cart?section_id=cart_data')
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          var part = txt.split('[t4s_split1]')[1];
          if (!part) return;
          var bits = part.split('[t4s_split2]');
          var count = (bits[0] || '').trim();
          var total = (bits[1] || '').trim();
          document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = count; });
          document.querySelectorAll('[data-cart-tt-price]').forEach(function (n) { n.innerHTML = total; });
          if (drawer) drawer.setAttribute('data-ccount', count);
          var html = document.documentElement;
          html.className = html.className.replace(/t4s-cart-count-\d+/, 't4s-cart-count-' + count);
        })
    );

    return Promise.all(jobs).then(function () {
      document.dispatchEvent(new CustomEvent('hdc:cart-refreshed'));
    });
  }

  function isDrawerOpen() {
    var d = drawerEl();
    if (!d) return false;
    if (d.getAttribute('aria-hidden') === 'false') return true;
    return d.classList.contains('is--visible') || d.classList.contains('is--opend') || d.classList.contains('is-open');
  }

  // Apelată de calculator după adăugarea în coș
  window.hdcOpenCart = function () {
    var trigger = drawerTrigger();
    var onCartPage = /\/cart\/?$/.test(window.location.pathname);
    if (!drawerEl() || !trigger || onCartPage) {
      window.location.href = root + 'cart';
      return;
    }
    refreshDrawer()
      .catch(function (e) { console.error('[Calculator coș] refresh', e); })
      .then(function () { if (!isDrawerOpen()) trigger.click(); });
  };

  /* ---------- Legătura material + manoperă ---------- */
  function line(cart, group, rol) {
    for (var i = 0; i < cart.items.length; i++) {
      var p = cart.items[i].properties || {};
      if (hdcGroupOf(p) === group && hdcRoleOf(p) === rol) return cart.items[i];
    }
    return null;
  }
  function removeGroup(group) {
    return getCart().then(function (cart) {
      var updates = {};
      cart.items.forEach(function (it) {
        if (hdcGroupOf(it.properties) === group) updates[it.key] = 0;
      });
      return post('cart/update.js', { updates: updates });
    });
  }
  function stepGroup(group, dir) {
    return getCart().then(function (cart) {
      var mat = line(cart, group, 'material');
      if (!mat) return removeGroup(group);
      var units = hdcMetersPerPiece(mat.properties);
      var oldPieces = Math.max(1, Math.round(mat.quantity / units));
      var pieces = oldPieces + dir;
      if (pieces < 1) return removeGroup(group);
      var qty = units * pieces;
      var matChanges = { 'Bucăți': String(pieces), 'Total metraj material': qty + ' m' };
      if (mat.properties['Împărțire'] !== undefined) matChanges['Împărțire'] = hdcSplitText(units * 100, hdcIsSplit2(mat.properties), pieces);
      var matProps = merge(mat.properties, matChanges);

      // Liniile legate se actualizează pe rând (cheia unei linii se schimbă după fiecare modificare)
      function updateRole(cartNow, rol) {
        var ln = line(cartNow, group, rol);
        if (!ln) return Promise.resolve(cartNow);
        var per = parseInt(ln.properties._hdc_unitati, 10) || Math.max(1, Math.round(ln.quantity / oldPieces)); // cm pe bucată
        if (rol === 'manopera' || rol === 'serviciu') {
          return post('cart/change.js', { id: ln.key, quantity: qty, properties: merge(ln.properties, { 'Total metraj material': qty + ' m' }) });
        }
        var q = per * pieces; // accesoriu: cm pe bucată × bucăți
        return post('cart/change.js', { id: ln.key, quantity: q, properties: merge(ln.properties, { 'Total': q + ' cm' }) });
      }

      return post('cart/change.js', { id: mat.key, quantity: qty, properties: matProps })
        .then(function (c) { return updateRole(c, 'manopera'); })
        .then(function (c) { return updateRole(c, 'serviciu'); })
        .then(function (c) { return updateRole(c, 'accesoriu'); });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hdc-cart-step],[data-hdc-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    busy = true;

    var group = btn.getAttribute('data-hdc-group');
    var item = btn.closest('[data-cart-item]');
    var inDrawer = !!btn.closest('#t4s-mini_cart');
    if (item) item.classList.add('is-hdc-busy');

    var action = btn.hasAttribute('data-hdc-cart-remove')
      ? removeGroup(group)
      : stepGroup(group, parseInt(btn.getAttribute('data-hdc-cart-step'), 10) || 0);

    action
      .then(function () {
        if (inDrawer) {
          // În coșul lateral: reîmprospătăm conținutul și drawer-ul rămâne deschis
          return refreshDrawer().then(function () { busy = false; });
        }
        window.location.reload(); // pe pagina coșului
      })
      .catch(function (err) {
        console.error('[Calculator coș]', err);
        busy = false;
        if (item) item.classList.remove('is-hdc-busy');
        alert((err && err.description) || 'Cantitatea dorită nu este disponibilă.');
      });
  }, true);
  /* ---------- Colecții: quick view / quick shop / adaugă rapid ----------
     Pe produsele cu calculator, butoanele rapide de pe carduri duc la pagina
     produsului, ca nimeni să nu poată cumpăra fără dimensiuni și manoperă. */
  var calcTag = String(window.hdcCalcTag || '').trim().toLowerCase();
  var calcCache = {};
  try { calcCache = JSON.parse(sessionStorage.getItem('hdcCalcCache') || '{}'); } catch (e) {}

  function handleFrom(el) {
    var href = el.getAttribute('href') || '';
    if (href.indexOf('/products/') === -1) {
      var card = el.closest('[data-product-options], .t4s-product, .t4s-product-wrapper, .t4s-col-item');
      var a = card && card.querySelector('a[href*="/products/"]');
      href = a ? a.getAttribute('href') : '';
    }
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function isCalcProduct(handle) {
    if (calcCache.hasOwnProperty(handle)) return Promise.resolve(calcCache[handle]);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) {
        var tags = (p.tags || []).map(function (t) { return String(t).trim().toLowerCase(); });
        calcCache[handle] = tags.indexOf(calcTag) !== -1;
        try { sessionStorage.setItem('hdcCalcCache', JSON.stringify(calcCache)); } catch (e) {}
        return calcCache[handle];
      })
      .catch(function () { return false; });
  }

  if (window.hdcCalcOn && calcTag) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action-quickview],[data-action-quickshop],[data-action-atc]');
      if (!btn) return;
      if (btn.hasAttribute('data-hdc-pass')) { btn.removeAttribute('data-hdc-pass'); return; } // lăsăm Kalles să continue
      if (btn.closest('[data-cart-wrapper], #t4s-mini_cart, .t4s-main-cart, [data-hdc]')) return;
      var handle = handleFrom(btn);
      if (!handle) return;

      // Răspuns știut deja: decidem pe loc
      if (calcCache.hasOwnProperty(handle)) {
        if (calcCache[handle]) {
          e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
          window.location.href = root + 'products/' + handle;
        }
        return;
      }

      // Nu știm încă: oprim clicul, verificăm produsul, apoi fie mergem la pagina lui, fie repetăm clicul pentru Kalles
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      isCalcProduct(handle).then(function (isCalc) {
        if (isCalc) { window.location.href = root + 'products/' + handle; return; }
        btn.setAttribute('data-hdc-pass', '');
        btn.click();
      });
    }, true);
  }
  /* ---------- Bara „livrare gratuită” de pe pagina de produs ----------
     Se actualizează după orice modificare a coșului: din calculator, din coșul lateral Kalles sau de oriunde. */
  function fsMoney(cents, format) {
    format = String(format || '{{amount}} lei');
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    function d(n, p, t, dc) {
      var parts = (n / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? dc + parts[1] : '');
    }
    var m = format.match(ph), v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = d(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = d(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = d(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = d(cents, 2, ' ', ','); break;
      default: v = d(cents, 2, ',', '.');
    }
    return m ? format.replace(ph, v) : v;
  }
  function fsUpdate(total) {
    var bars = document.querySelectorAll('[data-hdc-freeship]');
    for (var i = 0; i < bars.length; i++) {
      var el = bars[i];
      var amount = parseInt(el.getAttribute('data-amount'), 10) || 0;
      if (!amount) continue;
      var steps = []; try { steps = JSON.parse(el.getAttribute('data-steps')); } catch (e) { steps = [25, 50, 75]; }
      var fmt = el.getAttribute('data-money-format');
      var pct, cls, html;
      if (total <= 0) {
        pct = 0; cls = steps[0];
        html = el.getAttribute('data-t1').replace('__MONEY__', fsMoney(amount, fmt));
      } else if (amount > total) {
        pct = total * 100 / amount;
        cls = pct < steps[0] ? steps[0] : (pct < steps[1] ? steps[1] : steps[2]);
        html = el.getAttribute('data-t2').replace('__MONEY__', fsMoney(amount - total, fmt));
      } else {
        pct = 100; cls = 100;
        html = el.getAttribute('data-t3');
      }
      if (cls == 100 && amount > total) cls = 99.99;
      el.setAttribute('data-t4s-percent', cls);
      el.querySelector('[data-hdc-freeship-text]').innerHTML = html;
      el.querySelector('[data-hdc-freeship-bar]').style.width = pct + '%';
    }
  }
  var fsTimer = null;
  function onCartChanged() {
    if (!document.querySelector('[data-hdc-freeship]')) return;
    clearTimeout(fsTimer);
    fsTimer = setTimeout(function () {
      getCart().then(function (c) { fsUpdate(c.total_price); }).catch(function () {});
    }, 350);
  }
  var CART_URL = /\/cart\/(add|change|update|clear)/;
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (CART_URL.test(url)) p.then(onCartChanged, onCartChanged);
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_URL.test(String(url || ''))) this.addEventListener('loadend', onCartChanged);
    return origOpen.apply(this, arguments);
  };
  /* ---------- Estimare livrare (zile lucrătoare, fără weekend și sărbători legale RO) ---------- */
  var RO_MONTHS = ['ian.', 'feb.', 'mar.', 'apr.', 'mai', 'iun.', 'iul.', 'aug.', 'sept.', 'oct.', 'nov.', 'dec.'];
  var RO_DAYS = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
  function utc(y, m, d) { return new Date(Date.UTC(y, m, d)); }
  function addDays(dt, n) { return new Date(dt.getTime() + n * 86400000); }
  function key(dt) { return dt.getUTCFullYear() + '-' + (dt.getUTCMonth() + 1) + '-' + dt.getUTCDate(); }
  function orthodoxEaster(y) {
    var a = y % 4, b = y % 7, c = y % 19, d = (19 * c + 15) % 30, e = (2 * a + 4 * b - d + 34) % 7;
    var m = Math.floor((d + e + 114) / 31), day = ((d + e + 114) % 31) + 1;
    return addDays(utc(y, m - 1, day), 13); // calendar iulian → gregorian (1900–2099)
  }
  var holidayCache = {};
  function holidays(y, closedRaw) {
    var ck = y + '|' + closedRaw;
    if (holidayCache[ck]) return holidayCache[ck];
    var h = {};
    [[1,1],[1,2],[1,6],[1,7],[1,24],[5,1],[6,1],[8,15],[11,30],[12,1],[12,25],[12,26]].forEach(function (x) { h[key(utc(y, x[0] - 1, x[1]))] = 1; });
    var e = orthodoxEaster(y);
    [-2, 0, 1, 49, 50].forEach(function (o) { h[key(addDays(e, o))] = 1; }); // Vinerea Mare, Paște, Rusalii
    String(closedRaw || '').split(',').forEach(function (t) {
      var m = t.trim().match(/^(\d{1,2})\.(\d{1,2})(?:\.(\d{4}))?$/);
      if (!m) return;
      if (m[3] && +m[3] !== y) return;
      h[key(utc(y, +m[2] - 1, +m[1]))] = 1;
    });
    return (holidayCache[ck] = h);
  }
  function isWorkday(dt, closedRaw) {
    var wd = dt.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    return !holidays(dt.getUTCFullYear(), closedRaw)[key(dt)];
  }
  function nowBucharest() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { date: utc(+parts.year, +parts.month - 1, +parts.day), hour: +parts.hour };
  }
  function addWorkdays(dt, n, closedRaw) {
    var d = dt, left = n;
    while (left > 0) { d = addDays(d, 1); if (isWorkday(d, closedRaw)) left--; }
    return d;
  }
  function computeEta(el) {
    var min = Math.max(0, parseInt(el.getAttribute('data-min'), 10) || 0);
    var max = Math.max(min, parseInt(el.getAttribute('data-max'), 10) || min);
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    if (isNaN(cutoff)) cutoff = 15;
    var closed = el.getAttribute('data-closed') || '';
    var now = nowBucharest();
    var beforeCutoff = now.hour < cutoff && isWorkday(now.date, closed);
    // ziua în care se procesează comanda
    var start = beforeCutoff ? now.date : addWorkdays(now.date, 1, closed);
    return { from: addWorkdays(start, min, closed), to: addWorkdays(start, max, closed), today: now.date, beforeCutoff: beforeCutoff, cutoff: cutoff };
  }
  function fmtRange(a, b) {
    var y = b.getUTCFullYear();
    if (key(a) === key(b)) return a.getUTCDate() + ' ' + RO_MONTHS[a.getUTCMonth()] + ' ' + y;
    if (a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear())
      return a.getUTCDate() + ' - ' + b.getUTCDate() + ' ' + RO_MONTHS[b.getUTCMonth()] + ' ' + y;
    return a.getUTCDate() + ' ' + RO_MONTHS[a.getUTCMonth()] + ' - ' + b.getUTCDate() + ' ' + RO_MONTHS[b.getUTCMonth()] + ' ' + y;
  }
  function fmtDay(dt, today) {
    var diff = Math.round((dt - today) / 86400000);
    if (diff === 0) return 'azi';
    if (diff === 1) return 'mâine';
    return RO_DAYS[dt.getUTCDay()] + ', ' + dt.getUTCDate() + ' ' + RO_MONTHS[dt.getUTCMonth()];
  }
  function renderEta() {
    try {
      document.querySelectorAll('[data-hdc-eta-box]').forEach(function (el) {
        var r = computeEta(el);
        el.querySelector('[data-hdc-eta-range]').textContent = fmtRange(r.from, r.to);
        el.hidden = false;
      });
      document.querySelectorAll('[data-hdc-eta-line]').forEach(function (el) {
        var r = computeEta(el);
        var tpl = el.getAttribute(r.beforeCutoff ? 'data-before' : 'data-after') || '';
        el.textContent = tpl.replace(/\[ora\]/g, (r.cutoff < 10 ? '0' : '') + r.cutoff + ':00').replace(/\[data\]/g, fmtDay(r.from, r.today));
        el.hidden = false;
      });
    } catch (e) { console.error('[Estimare livrare]', e); }
  }
  window.hdcRenderEta = renderEta;
  renderEta();
  setInterval(renderEta, 5 * 60 * 1000); // trece de ora limită fără reîncărcare
})();